// HARD-OFF: PostHog analytics disabled - no external telemetry
// Original import removed: import posthog from 'posthog-js';

/**
 * AnalyticsHelper class - DISABLED (no-op implementation)
 * All methods are no-ops to prevent external analytics calls
 * @class AnalyticsHelper
 */
export class AnalyticsHelper {
  /**
   * @constructor
   * @param {Object} [options={}] - options for analytics (ignored)
   */
  // eslint-disable-next-line no-unused-vars
  constructor(options = {}) {
    this.analytics = null;
    this.user = {};
  }

  /**
   * Initialize analytics - NO-OP
   * @function
   * @async
   */
  async init() {
    // NO-OP: Analytics disabled
  }

  /**
   * Identify the user - NO-OP
   * @function
   * @param {Object} user - User object (ignored)
   */
  // eslint-disable-next-line no-unused-vars
  identify(user) {
    // NO-OP: Analytics disabled
  }

  /**
   * Track any event - NO-OP
   * @function
   * @param {string} eventName - event name (ignored)
   * @param {Object} [properties={}] - event properties (ignored)
   */
  // eslint-disable-next-line no-unused-vars
  track(eventName, properties = {}) {
    // NO-OP: Analytics disabled
  }

  /**
   * Track the page views - NO-OP
   * @function
   * @param {Object} params - Page view properties (ignored)
   */
  // eslint-disable-next-line no-unused-vars
  page(params) {
    // NO-OP: Analytics disabled
  }
}

// This object is shared across, the init is called in app/javascript/entrypoints/dashboard.js
export default new AnalyticsHelper(window.analyticsConfig);
